import { useContext } from 'react';

import NavigationLinkContext from '../contexts/NavigationLink';

const useNavigationLink = () => useContext(NavigationLinkContext);

export default useNavigationLink;
